import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {InteractiveDateTimeFormatterContainer} from '../../../../../components/common/formatters/dateTime/interactiveDateTimeFormatterContainer';

/*
 * Props.
 */

interface ConversationCardLastActivityProps {
  lastActivityAt: number;
}

/*
 * Styles.
 */

const StyledConvTime = styled.div`
  grid-area: last-activity;
  justify-self: end;

  padding-left: 2px;
  color: ${(p) => p.theme.greys.shade60};
  text-transform: uppercase;
  font-size: ${fontSizes.tiny};
  line-height: 18px;
`;

/*
 * Component.
 */

export const ConversationCardLastActivity: FC<ConversationCardLastActivityProps> = ({lastActivityAt}) => (
  <StyledConvTime>
    <InteractiveDateTimeFormatterContainer value={lastActivityAt} />
  </StyledConvTime>
);
